<template>
  <a-row class="demo-detail">
    <a-breadcrumb class="a-bread-sty" separator=">">
      <a-breadcrumb-item v-for="item in breadList" :key="item.name">
        <router-link :to="{ path: item.path === '' ? '/' : item.path }">{{
          item.meta.title
        }}</router-link>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <h2 align="center">酿酒行业控制系统解决方案</h2>

    <div class="top">
      <p>
        精酿啤酒的酿造是一个精密而复杂的过程，涉及多个环节和参数的控制。在现代化的精酿啤酒设备中，控制系统扮演着至关重要的角色。这些先进的系统通过自动化和监测技术，提供了的控制和调节，以优化酿造过程中的关键环节。本文将探讨精酿啤酒设备中常见的控制系统功能，以及它们对酿造质量和效率的重要影响。
      </p>
      <img src="../../assets/image/adminName.png" />
    </div>
    <div class="proj-role">
      <p class="proj-one">项目作用</p>
      <p class="proj-t">
        精酿啤酒设备中的控制系统是实现酿造过程控制和优化的关键工具。通过温度、时间、流量、PH值和溶解氧的控制，以及自动清洗、数据记录和远程操作等功能，控制系统确保了产品质量的一致性和卫生标准的遵守。这些先进的控制系统为精酿啤酒行业带来了更高的生产效率、质量控制和创新能力，为酿酒师提供了更大的灵活性和便利性。
      </p>
    </div>

    <h2 align="center">酿酒行业控制系统解决方案</h2>
    <p class="to-p" align="center">
      精通国际主流控制系统平台，为酿造行业定制化开发工艺模版，提高生产控制系统稳定性和控制精度。
    </p>

    <div class="swiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="item in planList"
          :key="item.id"
          @mouseover="switchItem(item)"
        >
          <img :src="item.img" />
        </div>
      </div>
    </div>

    <!-- <h2 align="center">项目亮点</h2>
    <div class="bottom-box">
      <img class="box-img" src="../../assets/image/32650.png">
      <ul class="list">
        <li>集中管控各生产线生产
          流程，减少了中间环节 </li>
        <li>报错机制，生产过程中
          的问题会有及时响应，提高生产效率。</li>
        <li>集中管控各生产线生
          产流程，减少了中间环节 </li>
        <li>报错机制，生产过程中的
          问题会有及时响应，提高生产效率。</li>
      </ul>
    </div> -->
  </a-row>
</template>

<script>
import Swiper from "../../../node_modules/swiper/swiper-bundle.js";
export default {
  mounted() {
    this.getBreadcrumb();
    var mySwiper = new Swiper(".swiper", {
      direction: "horizontal", //
      loop: true,
      breakpoints: {
        320: {
          //当屏幕宽度大于等于320
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          //当屏幕宽度大于等于768
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1280: {
          //当屏幕宽度大于等于1280
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
      autoplay: {
        delay: 1000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      disableOnInteraction: false,
    });
  },
  data() {
    return {
      planList: [
        {
          id: 1,
          img: require("../../assets/image/brew1.png"),
        },
        {
          id: 2,
          img: require("../../assets/image/brew2.png"),
        },
        {
          id: 3,
          img: require("../../assets/image/brew3.png"),
        },
        {
          id: 4,
          img: require("../../assets/image/brew4.png"),
        },
      ],

      breadName: "",
      breadList: [],
    };
  },
  methods: {
    getBreadcrumb() {
      this.breadList = [];
      this.breadName = this.$route.name;
      this.$route.matched.forEach((ele, index, arr) => {
        this.breadList.push(ele);
      });
    },
  },
};
</script>

<style lang="less">
.demo-detail {
  margin: 0 auto;
  h2 {
    margin-top: 120px;
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }
  .a-bread-sty {
    width: 1440px;
    margin: 40px auto;
    font-size: 20px;
  }
  .top {
    width: 1440px;
    margin: 0 auto;
    margin-top: 140px;
    padding: 51px;
    background: linear-gradient(#f9fafe, #e7eeff);
    border-radius: 20px;
    box-shadow: 0 10px 20px #cccccc;
    display: flex;
    align-items: center;
    img {
      width: 200px;
      height: 300px;
    }
  }
  .to-p {
    margin-bottom: 40px;
  }
  .swiper {
    width: 1440px;
    border-radius: 20px;
    .swiper-slide {
      img {
        width: 100%;
        height: 200px;
      }
    }
  }
  .proj-role {
    margin: 0 auto;
    margin-top: 150px;
    width: 1440px;
    border-radius: 25px;
    padding: 50px;
    color: #ffffff;
    // background: linear-gradient(to right, #ff6600, #ff9354);
    background: url("../../assets/image/32647.png") no-repeat;
    background-size: cover;
    box-shadow: 0 10px 20px #cccccc;
    .proj-one {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
    }
    .proj-t {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
    }
  }
  .bottom-box {
    width: 100%;
    background: url("../../assets/image/32651.png");
    text-align: center;

    .box-img {
      width: 1440px;
      height: 529px;
    }
    .list {
      margin: 0 auto;
      width: 1440px;

      display: flex;
      justify-content: space-between;
      padding-bottom: 50px;
      li {
        width: 20%;
        &:nth-child(1),
        &:nth-child(4) {
          margin-top: -220px;
        }
        &:nth-child(2),
        &:nth-child(3) {
          margin-top: -50px;
        }
      }
    }
  }
}

@media all and (max-width: 700px) {
    .demo-detail {
      margin: 0 auto;
      padding: 0 200px;
      h2 {
        margin-top: 120px;
        font-size: 80px;
        font-family: Source Han Sans CN;
        font-weight: bold;
      }
  
      .a-bread-sty {
        width: 1440px;
        margin: 40px auto;
        font-size: 40px;
      }
  
      .top {
        width: 1440px;
        margin: 0 auto;
        margin-top: 140px;
        padding: 51px;
        background: linear-gradient(#f9fafe, #e7eeff);
        border-radius: 20px;
        box-shadow: 0 10px 20px #cccccc;
        display: flex;
        align-items: center;
  
        img {
          width: 200px;
          height: 300px;
        }
        p {
          font-size: 48px;
        }
      }
  
      .to-p {
        margin-bottom: 40px;
        font-size: 48px;
      }
  
      .swiper {
        width: 1440px;
        border-radius: 20px;
  
        .swiper-slide {
          img {
            width: 100%;
            height: 200px;
          }
        }
      }
  
      .proj-role {
        margin: 0 auto;
        margin-top: 150px;
        width: 1440px;
        border-radius: 25px;
        padding: 50px;
        color: #ffffff;
        background: url("../../assets/image/32647.png") no-repeat;
        background-size: cover;
        box-shadow: 0 10px 20px #cccccc;
  
        .proj-one {
          font-size: 80px;
          font-family: Source Han Sans CN;
          font-weight: bold;
        }
  
        .proj-t {
          font-size: 48px;
          font-family: Source Han Sans CN;
          font-weight: 400;
        }
      }
  
      .bottom-box {
        width: 100%;
        background: url("../../assets/image/32651.png");
        text-align: center;
  
        .box-img {
          width: 1440px;
          height: 529px;
        }
  
        .list {
          margin: 0 auto;
          width: 1440px;
  
          display: flex;
          justify-content: space-between;
          padding-bottom: 50px;
  
          li {
            width: 20%;
  
            &:nth-child(1),
            &:nth-child(4) {
              margin-top: -220px;
            }
  
            &:nth-child(2),
            &:nth-child(3) {
              margin-top: -50px;
            }
          }
        }
      }
    }
  }
</style>
